import { render } from "./GameLobby.vue?vue&type=template&id=313ed2f6&scoped=true"
import script from "./GameLobby.vue?vue&type=script&lang=js"
export * from "./GameLobby.vue?vue&type=script&lang=js"

import "./GameLobby.vue?vue&type=style&index=0&id=313ed2f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-313ed2f6"]])

export default __exports__